<script lang="ts">
import { SvelteToast } from '@zerodevx/svelte-toast'

import Router from 'svelte-spa-router'
import RouteTop     from './routes/Top.svelte'
import RouteAnswer  from './routes/Answer.svelte'
import RouteGenerate from './routes/Generate.svelte'
import RouteResolve from './routes/Resolve.svelte'
import RouteError   from './__error.svelte'

import TheHeader from './components/TheHeader.svelte';
import TheFooter from './components/TheFooter.svelte';

const routes = {
    '/':                           RouteTop,
    '/generate/':                  RouteGenerate,
    '/answer/:hash/:message/:key': RouteAnswer,
    '/resolve/':                   RouteResolve,
    '/resolve/:message':           RouteResolve,
    '*':                           RouteError,
}

const toastOptions = {
    reversed: true,
    intro: { y: 192 },
    duration: 2000,
    theme: {
        '--toastBackground': '#48BB78',
        '--toastBarBackground': '#2F855A'
    }
}
</script>

<template lang="pug">
TheHeader
Router({routes})
TheFooter

SvelteToast(options="{toastOptions}")
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+Antique:wght@300;400;700&display=swap');

:global(:root) {
    // *** 色関係
    --color-red:          #f01d32;
    --color-orange:       #f0711d;
    --color-green:        #30cf70;
    --color-yellow-green: #9cf01d;
    --color-black:        #14171a;
    --color-white:        #ffffff;
    --color-gray:         #bdbdbd;
    --color-gray-light:   #cfd9de;
    
    --color-twitter: #1d9cf0;

    --color-font-default:      var(--color-black);
    --color-font-red:          var(--color-red);
    --color-font-orange:       var(--color-orange);
    --color-font-blue:         var(--color-twitter);
    --color-font-placeholder:  var(--color-gray);

    --color-border-line:       var(--color-gray-light);

    // *** トースト
    --toastContainerTop: auto;
    --toastContainerRight: auto;
    --toastContainerBottom: 5rem;
    --toastContainerLeft: calc(50vw - 8rem);
}


:global(.__margin-top__3pct) {
    margin-top: 3%;
}
:global(.__font-color__red) {
    color: var(--color-font-red);
}
:global(.__font-color__blue) {
    color: var(--color-font-blue);
}
:global(.__placeholder-font-color__gray) {
    &::placeholder {
        color: var(--color-font-placeholder);
    }
}
:global(.__hover-opacity__0-5) {
    cursor: pointer;
    &:hover {
        opacity: .5;
    }
}

:global(*) {
    font-family: 'Zen Kaku Gothic Antique', sans-serif;
}

:global(html) {
    font-size: 16px;
    @media screen and (max-width:768px) {
        font-size: 2vw;
    }
    @media screen and (max-width:480px) {
        font-size: 2.5vw;
    }
}

:global(.pc) {
    display: block;
    @media screen and (max-width:480px) {
        display: none !important;
    }
}
:global(.sp) {
    display: none;
    @media screen and (max-width:480px) {
        display: block;
    }
}

:global(body) {
    min-height: 100vh;
    padding: 0 0 7rem 0;
    position: relative;
    color: var(--color-font-default);
}
:global(img) {
    width: 100%;
}
:global(hr) {
    margin: 2rem 0;
}
:global(.container) {
    widows: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 1.5rem;
}
:global(.) {
    font-size: 1rem;
}
:global(.main__h3__text) {
    font-size: 0.8rem;
}
</style>